"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[862],{

/***/ 862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_CommonUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4250);
/* harmony import */ var _utils_htmlUtil_htmlFooterDT__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7460);



var FooterRoutePWA = function(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, footer = ref.footer_data, isIntl = ref.isIntl;
    var footerData = footer || "";
    if (footerData === "" && isIntl) {
        footerData = _utils_htmlUtil_htmlFooterDT__WEBPACK_IMPORTED_MODULE_2__/* .footerIntlPWA */ .s5;
    } else if (footerData === "") {
        footerData = _utils_htmlUtil_htmlFooterDT__WEBPACK_IMPORTED_MODULE_2__/* .footerDomPWA */ .TW;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "footer_block",
            className: "pwa",
            children: (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_1__/* .transformToHtml */ .cR)(footerData)
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FooterRoutePWA);


/***/ })

}]);